import api from "./api";

class RepositoryService {

  getData(route, body) {
    return api
      .post(
        route,
        body,
      )
      .then((response) => {
        if (response.data.success == 1)
          return response.data;
      });
  }
  postData(route, body) {
    return api
      .post(
        route,
        body,
      )
      .then((response) => {
        if (response.data.success == 1)
          return response.data;
      });
  }
  updateData(route, body) {
    return api
      .put(
        route,
        body,
      )
      .then((response) => {
        if (response.data.success == 1)
          return response.data;
      });
  }
  isDeleteData(route, body) {
    return api
      .patch(
        route,
        body
      )
      .then((response) => {
        if (response.data.success == 1)
          return response.data;
      });
  }
  deleteData(route) {
    return api
      .delete(
        route
      )
      .then((response) => {
        if (response.data.success == 1)
          return response.data;
      });
  }
}

export default new RepositoryService();
